// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as CarRentalNoDepositBucharestRouteImport } from './routes/car-rental-no-deposit-bucharest'
import { Route as CarRentalOtopeniAirportRouteImport } from './routes/car-rental-otopeni-airport'
import { Route as GoodToKnowRouteImport } from './routes/good-to-know'
import { Route as LoginRouteImport } from './routes/login'
import { Route as LuxuryCarRentalBucharestRouteImport } from './routes/luxury-car-rental-bucharest'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as RentACarWithoutCreditCardBucharestRouteImport } from './routes/rent-a-car-without-credit-card-bucharest'
import { Route as UnsubscribeRouteImport } from './routes/unsubscribe'
import { Route as LocaleIndexRouteImport } from './routes/$locale.index'
import { Route as LocaleSlugRouteImport } from './routes/$locale.$slug'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated/admin'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'
import { Route as ReconfirmTokenRouteImport } from './routes/reconfirm.$token'
import { Route as RentalsIndexRouteImport } from './routes/rentals.index'
import { Route as RentalsSlugRouteImport } from './routes/rentals.$slug'
import { Route as RoIndexRouteImport } from './routes/ro.index'
import { Route as RoInchirieriAutoFaraGarantieRouteImport } from './routes/ro.inchirieri-auto-fara-garantie'
import { Route as RoInchirieriAutoOtopeniRouteImport } from './routes/ro.inchirieri-auto-otopeni'
import { Route as AuthenticatedPortalIndexRouteImport } from './routes/_authenticated/portal.index'
import { Route as AuthenticatedPortalIdRouteImport } from './routes/_authenticated/portal.$id'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const CarRentalNoDepositBucharestRoute = CarRentalNoDepositBucharestRouteImport.update({
            id: '/car-rental-no-deposit-bucharest',path: '/car-rental-no-deposit-bucharest',getParentRoute: () => rootRouteImport
          })
const CarRentalOtopeniAirportRoute = CarRentalOtopeniAirportRouteImport.update({
            id: '/car-rental-otopeni-airport',path: '/car-rental-otopeni-airport',getParentRoute: () => rootRouteImport
          })
const GoodToKnowRoute = GoodToKnowRouteImport.update({
            id: '/good-to-know',path: '/good-to-know',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const LuxuryCarRentalBucharestRoute = LuxuryCarRentalBucharestRouteImport.update({
            id: '/luxury-car-rental-bucharest',path: '/luxury-car-rental-bucharest',getParentRoute: () => rootRouteImport
          })
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => rootRouteImport
          })
const RegisterRoute = RegisterRouteImport.update({
            id: '/register',path: '/register',getParentRoute: () => rootRouteImport
          })
const RentACarWithoutCreditCardBucharestRoute = RentACarWithoutCreditCardBucharestRouteImport.update({
            id: '/rent-a-car-without-credit-card-bucharest',path: '/rent-a-car-without-credit-card-bucharest',getParentRoute: () => rootRouteImport
          })
const UnsubscribeRoute = UnsubscribeRouteImport.update({
            id: '/unsubscribe',path: '/unsubscribe',getParentRoute: () => rootRouteImport
          })
const LocaleIndexRoute = LocaleIndexRouteImport.update({
            id: '/$locale/',path: '/$locale/',getParentRoute: () => rootRouteImport
          })
const LocaleSlugRoute = LocaleSlugRouteImport.update({
            id: '/$locale/$slug',path: '/$locale/$slug',getParentRoute: () => rootRouteImport
          })
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => AuthenticatedRouteRoute
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => rootRouteImport
          })
const ReconfirmTokenRoute = ReconfirmTokenRouteImport.update({
            id: '/reconfirm/$token',path: '/reconfirm/$token',getParentRoute: () => rootRouteImport
          })
const RentalsIndexRoute = RentalsIndexRouteImport.update({
            id: '/rentals/',path: '/rentals/',getParentRoute: () => rootRouteImport
          })
const RentalsSlugRoute = RentalsSlugRouteImport.update({
            id: '/rentals/$slug',path: '/rentals/$slug',getParentRoute: () => rootRouteImport
          })
const RoIndexRoute = RoIndexRouteImport.update({
            id: '/ro/',path: '/ro/',getParentRoute: () => rootRouteImport
          })
const RoInchirieriAutoFaraGarantieRoute = RoInchirieriAutoFaraGarantieRouteImport.update({
            id: '/ro/inchirieri-auto-fara-garantie',path: '/ro/inchirieri-auto-fara-garantie',getParentRoute: () => rootRouteImport
          })
const RoInchirieriAutoOtopeniRoute = RoInchirieriAutoOtopeniRouteImport.update({
            id: '/ro/inchirieri-auto-otopeni',path: '/ro/inchirieri-auto-otopeni',getParentRoute: () => rootRouteImport
          })
const AuthenticatedPortalIndexRoute = AuthenticatedPortalIndexRouteImport.update({
            id: '/portal/',path: '/portal/',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedPortalIdRoute = AuthenticatedPortalIdRouteImport.update({
            id: '/portal/$id',path: '/portal/$id',getParentRoute: () => AuthenticatedRouteRoute
          })





const AuthenticatedRouteRouteChildren = {
  AuthenticatedAdminRoute: AuthenticatedAdminRoute,AuthenticatedPortalIdRoute: AuthenticatedPortalIdRoute,AuthenticatedPortalIndexRoute: AuthenticatedPortalIndexRoute
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,AuthRoute: AuthRoute,CarRentalNoDepositBucharestRoute: CarRentalNoDepositBucharestRoute,CarRentalOtopeniAirportRoute: CarRentalOtopeniAirportRoute,GoodToKnowRoute: GoodToKnowRoute,LoginRoute: LoginRoute,LuxuryCarRentalBucharestRoute: LuxuryCarRentalBucharestRoute,PrivacyPolicyRoute: PrivacyPolicyRoute,RegisterRoute: RegisterRoute,RentACarWithoutCreditCardBucharestRoute: RentACarWithoutCreditCardBucharestRoute,UnsubscribeRoute: UnsubscribeRoute,LocaleSlugRoute: LocaleSlugRoute,BlogSlugRoute: BlogSlugRoute,ReconfirmTokenRoute: ReconfirmTokenRoute,RentalsSlugRoute: RentalsSlugRoute,RoInchirieriAutoFaraGarantieRoute: RoInchirieriAutoFaraGarantieRoute,RoInchirieriAutoOtopeniRoute: RoInchirieriAutoOtopeniRoute,LocaleIndexRoute: LocaleIndexRoute,BlogIndexRoute: BlogIndexRoute,RentalsIndexRoute: RentalsIndexRoute,RoIndexRoute: RoIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)